import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getQuery } from '../../monitoring/utils';
import { useScrollStream } from './useScrollStream';

export const useSelectAndScrollToFileOnMount = (selectItem) => {
  const { search } = useLocation();
  const itemIdFromSearch = getQuery(search).selectedItem;
  const { emitScroll } = useScrollStream();

  useEffect(() => {
    if (itemIdFromSearch) {
      setTimeout(() => {
        selectItem(itemIdFromSearch);
        emitScroll(itemIdFromSearch);
      }, 0);
    }
  }, [itemIdFromSearch]);
};
